import { Control, Controller, useWatch } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { InputNumber } from 'antd';
import { PROMOTION_TYPE_MAP } from 'constant/pms-product';

const ProductOriginalPrice = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  const promotionType = useWatch({ control, name: 'promotionType' });
  if (promotionType !== PROMOTION_TYPE_MAP.SPECIAL) {
    return null;
  }
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.original_price)}:</FormLabel>
      <Controller
        name="originalPrice"
        control={control}
        render={({ field }) => (
          <InputNumber
            className="w-full"
            placeholder={i18n.t(LOCALS.please_enter) || ''}
            {...field}
            min={0}
            max={99999999}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={(value) => value!.replace(/\$\s?|(,*)/g, '') as any}
          />
        )}
      />
    </div>
  );
};

export default ProductOriginalPrice;
